<template>
    <div id="app">
        <main role="main" class="container">
            <h1 class="mt-5 text-center">Mighty Password Generator</h1>
            <ul class="word-cloud">
                <li v-for="(word, i) in words" :key="i">
                    <a href="#">
                        <code @click.prevent="toggleWordPicked(i)" :class="{picked: isPicked(word)}">
                            {{ word }}
                            <sup class="close" v-if="isPicked(word)">
                                X
                            </sup>
                        </code>
                    </a>
                </li>
                <li style="float: right; clear: both">
                    <a href="#" @click.prevent="moreWords()" class="text-muted">... show 100 more</a>
                </li>
            </ul>
            <hr>
            <div class="row justify-content-md-center">
                <div class="col-md-4 ">
                    <input type="result" class="form-control form-control-lg" :value="password" />
                </div>
            </div>
        </main>
        <footer class="footer">
            <div class="container">
                <span class="text-muted">Use at own risk</span>
            </div>
        </footer>
    </div>
</template>

<script>
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.css';

export default {
    name: 'app',
    data() {
        return {
            dict: [],
            words: [],
            chosenWords: [],
            style: "kebap"
        }
    },
    components: {

    },
    computed: {
        password() {
            return this.formatPassword(this.style);
        },
    },
    async mounted() {
        const dictResponse = await axios.get('/data/dict.txt', {
            responseType: 'text'
        });

        this.dict = dictResponse.data.split('\n');
        this.moreWords(300);
    },


    methods: {
        moreWords(count=100) {
            this.words= [...this.words, ...this.getRandomWords(count)];
        },
        maybeSeparator(i) {
            return i < this.chosenWords.length - 1 ? '-' : '';
        },
        formatPassword(style) {
            if (style === 'kebap') 
                return this.chosenWords.join('-');

            if (style === 'camel') {
                return this.chosenWords.map( (word, index) => { 
                    if (index === 0) return word
                    return word[0].toUpperCase() + word.slice(1);
                }).join('');
            }

            return style;
        },
        passwordGlue(index) {
            if (index < this.chosenWords.length - 1 ) {
                return '-';
            }
            return '';
        },
        getRandomWords(count) {
            const array = new Uint32Array(count);
            const crypto = window.crypto || window.msCrypto;
            crypto.getRandomValues(array);
            const randomWords = [];
            // Grab a random word, push it to the password array
            for (var i = 0; i < array.length; i++) {
                var index = (array[i] % this.dict.length);
                randomWords.push(this.dict[index]);
            }
            return randomWords;
        },
        toggleWordPicked(index) {
            const word = this.words[index];

            if (this.chosenWords.indexOf(word) === -1 ) {
                this.chosenWords.push(word);
            } else {
                this.chosenWords.splice(this.chosenWords.indexOf(word), 1);
            }
        },
        isPicked(word) {
            return this.chosenWords.indexOf(word) > -1 ;
        }
    }
}
</script>

<style>
    html { position: relative; min-height: 100%; }
    body { margin-bottom: 60px; /* Margin bottom by footer height */ }
    .footer { position: absolute; bottom: 0; width: 100%; height: 60px; /* Set the fixed height of the footer here */ line-height: 60px; /* Vertically center the text there */ background-color: #f5f5f5; }
    .container { width: auto; max-width: 1280px; padding: 0 15px; }
    .chosen-words li { float: left; list-style-type: none; }

    .word-cloud li { float: left; list-style-type: none; margin-left: 10px; position: relative; }
    .word-cloud a { text-decoration: none; }
    hr { clear: both; margin-top: 10px }
    .picked { font-weight: bold;  }
    sup.close { position: absolute; font-size: 10px; top: 2px; }
</style>
